import { produce } from 'immer'
import Actions from '../actions'

const initialState = {
  plans: [],
  planRank: null,
  isPlansLoading: false,
  isRankingDataLoading: false,
  rankingData: [],
  comparePlans: [],
  savedPlans: [],
  selectedPlan: null,
  isPlanPriceDialogVisable: false,
  isShareQuoteLoading: false
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.PLAN_RANKS_REQUESTED: {
      draft.isRankingDataLoading = true
      break
    }
    case Actions.PLAN_RANKS_RECEIVED: {
      draft.rankingData = payload?.rankingData
      draft.isRankingDataLoading = false
      break
    }
    case Actions.PLAN_RANK_SELECTED: {
      draft.planRank = payload?.planRank
      break
    }
    case Actions.PLANS_REQUESTED: {
      draft.isPlansLoading = true
      break
    }
    case Actions.PLANS_RECEIVED: {
      draft.plans = payload?.plans
      draft.isPlansLoading = false
      break
    }
    case Actions.PLAN_COMPARE_ADDED: {
      draft.comparePlans.push(payload?.plan)
      break
    }
    case Actions.PLAN_COMPARE_REMOVED: {
      draft.comparePlans = draft.comparePlans.filter(
        plan => plan?.antidote_plan_id !== payload?.plan?.antidote_plan_id
      )
      break
    }
    case Actions.PLAN_COMPARE_CLEARED: {
      draft.comparePlans = []
      break
    }
    case Actions.PLAN_SAVE_ADDED: {
      draft.savedPlans = [...draft.savedPlans, payload?.plan]
      break
    }
    case Actions.PLAN_SAVE_REMOVED: {
      draft.savedPlans = draft.savedPlans?.filter(
        plan => plan?.antidote_plan_id !== payload?.plan?.antidote_plan_id
      )
      break
    }
    case Actions.PLAN_SELECTED: {
      draft.selectedPlan = payload?.plan
      break
    }
    case Actions.PLAN_PRICE_DIALOG_CLOSED: {
      draft.isPlanPriceDialogVisable = false
      break
    }
    case Actions.PLAN_PRICE_CHANGED: {
      draft.selectedPlan.plan_rate_multiplied = payload?.plan_rate_multiplied
      draft.isPlanPriceDialogVisable = true
      break
    }
    case Actions.SHARE_QUOTE_REQUESTED: {
      draft.isShareQuoteLoading = true
      break
    }
    case Actions.SHARE_QUOTE_RECEIVED: {
      draft.isShareQuoteLoading = false
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
